import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';

import * as CertificationActions from './certification.actions';
import { occupationDetailWithBusinessRulesReady } from '../occupation-detail/occupation-detail.actions';
import { OccupationDetailFacade } from '../occupation-detail';

@Injectable()
export class CertificationEffects {
  occupationDetailWithBusinessRulesReady$ = createEffect(() =>
    this.actions$.pipe(
      ofType(occupationDetailWithBusinessRulesReady),
      map(() => CertificationActions.loadCertifications())
    )
  );

  loadCertifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CertificationActions.loadCertifications),
      withLatestFrom(this.occupationDetailFacade.occupationDetail$),
      map(([, { certificates }]) =>
        CertificationActions.certificationsLoadedSuccess({
          certifications: certificates
        })
      )
    );
  });

  constructor(
    private actions$: Actions,
    private occupationDetailFacade: OccupationDetailFacade
  ) {}
}
